export function getTableHeaderRowSpan(areReportsBeingEdited: boolean) {
    return areReportsBeingEdited ? 8 : 7;
}
